module.exports = __webpack_public_path__ + "img/c02_unitspearman_Normal_ua.116d5cf6.webp";